import { render, staticRenderFns } from "./SecondaryMetricLineIcon.vue?vue&type=template&id=74bc37ba&scoped=true"
import script from "./SecondaryMetricLineIcon.vue?vue&type=script&lang=js"
export * from "./SecondaryMetricLineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc37ba",
  null
  
)

export default component.exports